import React, { useState } from "react";
import { graphql, useLazyLoadQuery, usePaginationFragment } from "react-relay";
import StatTable from "../../../StatTable";
import Button from "../../../Button";

const GET_PGA_RECENT_HISTORY = graphql`
  fragment PGARecentHistoryTable_query on Query
  @argumentDefinitions(
    playerId: { type: "ID!" }
    count: { type: Int, defaultValue: 10 }
    cursor: { type: String, defaultValue: null }
  )
  @refetchable(queryName: "PGARecentHistoryTablePaginationQuery") {
    pgaRecentHistoryForDkPlayer(
      dkPlayerId: $playerId
      first: $count
      after: $cursor
    ) @connection(key: "PGARecentHistoryTable_pgaRecentHistoryForDkPlayer") {
      edges {
        node {
          id
          strokesGainedApproachTheGreen
          strokesGainedAroundTheGreen
          strokesGainedBallStriking
          strokesGainedIronPlay
          strokesGainedOffTheTee
          strokesGainedPutting
          strokesGainedShortGame
          strokesGainedTeeToGreen
          strokesGainedTotal

          goodDriveRatio

          currentPosition

          dkScore
          eventToPar

          event {
            startDate
            shortEndDate

            tournament {
              officialName
            }
          }
        }
      }
    }
  }
`;

export default function PGARecentHistoryTable(props) {
  const { data, error, loadNext } = usePaginationFragment(
    GET_PGA_RECENT_HISTORY,
    props.query
  );

  const tableData = React.useMemo(
    () =>
      data.pgaRecentHistoryForDkPlayer.edges.map((eventPlayerNode) => {
        const eventPlayer = eventPlayerNode.node;

        const newEP = { ...eventPlayer };

        newEP.startDate = eventPlayer.event.shortEndDate;
        newEP.rowTitle = eventPlayer.event.tournament.officialName;

        newEP.goodDrives = eventPlayer.goodDriveRatio;

        return newEP;
      }),
    [props.playerId]
  );

  let headers = [];

  if (props.showMore) {
    headers = [
      { Header: "Event", accessor: "rowTitle" },
      { Header: "Finish", accessor: "currentPosition" },
      { Header: "To Par", accessor: "eventToPar" },
      { Header: "DK", accessor: "dkScore" },
      { Header: "SG: TOT", accessor: "strokesGainedTotal" },
      { Header: "SG: T2G", accessor: "strokesGainedTeeToGreen" },
      { Header: "SG: BS", accessor: "strokesGainedBallStriking" },
      { Header: "SG: SHORT", accessor: "strokesGainedShortGame" },
      { Header: "SG: IRON", accessor: "strokesGainedIronPlay" },
      { Header: "SG: OTT", accessor: "strokesGainedOffTheTee" },
      { Header: "SG: APP", accessor: "strokesGainedApproachTheGreen" },
      { Header: "SG: ARG", accessor: "strokesGainedAroundTheGreen" },
      { Header: "SG: PUTT", accessor: "strokesGainedPutting" },
    ];
  } else {
    headers = [
      { Header: "Date", accessor: "startDate" },
      { Header: "SG: OTT", accessor: "strokesGainedOffTheTee" },
      { Header: "SG: T2G", accessor: "strokesGainedTeeToGreen" },
      { Header: "SG: PUTT", accessor: "strokesGainedPutting" },
      { Header: "SG: IRON", accessor: "strokesGainedIronPlay" },
      // { Header: "Good Drives", accessor: "goodDrives" },
    ];
  }

  return (
    <div>
      <StatTable columns={headers} data={tableData} />
      {props.showMore ? (
        <div>
          {/*TODO: Fix loadNext call <Button onClick={loadNext}>Load More Events</Button>*/}
          <p>Showing last {tableData.length} tournaments.</p>
        </div>
      ) : (
        <div>
          <a
            href={`/tools/pga-profile/${props.playerId}`}
            target="_blank"
            rel="noreferrer"
            className="pga-recent-history-see-more-link"
          >
            See More
          </a>
        </div>
      )}
    </div>
  );
}
